import { AccordionAnimatedContent } from '../../Accordion'
import { useWidgetContext } from '../Widget.hooks'
import { WidgetContentSkeleton } from '../WidgetContentSkeleton'

import * as styles from './WidgetContentContainer.module.css'

function WidgetContentContainer({
  Container = 'div',
  Skeleton = WidgetContentSkeleton,
  children,
  className = styles.WidgetContentContainer,
  contentWrapperClassName = styles.accordionContentWrapper,
  skeletonProps,
}) {
  const { isExpanded, isSkeleton } = useWidgetContext()

  return isSkeleton || children ? (
    <AccordionAnimatedContent
      contentWrapperClassName={contentWrapperClassName}
      isOpen={isExpanded}
    >
      <Container className={className}>
        {isSkeleton ? (
          Skeleton ? (
            <Skeleton {...skeletonProps} />
          ) : null
        ) : (
          children
        )}
      </Container>
    </AccordionAnimatedContent>
  ) : null
}

export default WidgetContentContainer
